import { Task } from "@/api/mutation/useTaskCreateMutation";
import Clock from "../../assets/svg/Clock.svg";
import UserAvatar from "../ui/userAvatar";
import calculateTimeDifference from "../shared/TimeDifferenceCalculate";
import dateFormater from "@/helperFuntions/dateFormater";
import { useTranslation } from "react-i18next";
function TaskHistory(props: { task: Task | undefined }) {
  // const [showAll, setShowAll] = useState<boolean>(false);
  const { t } = useTranslation();
  function isValidDate(dateString: string) {
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
    return regex.test(dateString);
  }

  const messageCreate = (history: Task["histories"][0]): string => {
    let message = history.message;
    if (
      history.data.newValue !== null &&
      history.data.newValue.toString() &&
      history.data.oldValue !== null &&
      history.data.oldValue?.toString()
    ) {
      if (
        isValidDate(history.data.newValue) &&
        isValidDate(history.data.oldValue)
      ) {
        message =
          message +
          "  " +
          dateFormater(new Date(history.data.oldValue)) +
          "  " +
          " to " +
          dateFormater(new Date(history.data.newValue));
      } else {
        message =
          message +
          " " +
          history.data.oldValue +
          " to " +
          history.data.newValue;
      }
    } else {
      if (isValidDate(history.data.newValue)) {
        message = dateFormater(new Date(history.data.newValue)) + " " + message;
      } else {
        message =
          (history.data.oldValue ?? history.data.newValue) + " " + message;
      }
    }
    return message;
  };

 return (
    <div className="flex flex-col h-full min-h-0">
      {/* Header */}
      <div className="flex items-center gap-2.5 mt-4 shrink-0">
        <img src={Clock} width={20} height={20} />
        <div className="text-xl font-medium">{t("History")}</div>
      </div>

      {/* Scroll Area */}
      <div className="flex-1 min-h-0 overflow-y-auto ">
        {props.task?.histories?.map((history) => (
          <div key={history.historyId} className="flex gap-3 items-center mt-3">
            <UserAvatar
              user={history.createdByUser}
              className="min-w-8 w-8"
            />

            <div className="flex flex-col">
              <div className="flex gap-2 items-center">
                <p className="text-sm font-semibold text-gray-450">
                  {history.createdByUser.firstName}
                </p>
                <p className="text-xs text-gray-450">
                  {calculateTimeDifference(new Date(history.createdAt))}
                </p>
              </div>

              <p className="text-xs text-gray-450">
                {messageCreate(history)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TaskHistory;
